// extracted by mini-css-extract-plugin
export default {"categoryBadge":"CategoryBadge-module__categoryBadge___ISpcc"};